import * as api from '../api'
import useApiMutation from './useApiMutation'
import useInvalidate from '../useInvalidate'

export default function useToggleUsersActive() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async ({ userUuids, isActive }: { userUuids: string[]; isActive: boolean }) => {
      await api.post(`user/status/${isActive ? 'active' : 'inactive'}`, userUuids)

      await Promise.all([invalidate.users()])
    },
  })
}
